import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { SearchCardI } from '../../models/list-view/kanbanList';

@Component({
  selector: 'anterasoftware-kanban-search-card',
  templateUrl: './kanban-search-card.component.html',
  styleUrls: ['./kanban-search-card.component.scss']
})
export class KanbanSearchCardComponent implements OnInit {

  @Input() public cardDetails: SearchCardI = {
    id: '',
    title: '',
    filterList: [],
    isTab: false,
    isShared: false,
    order: 0,
    editPermission: true,
    isHide: false,
  };
  @Input() public page = '';
  @Input() public mappingFields: any[] =  [];

  @Output() public onDeleteCard: EventEmitter<any> = new EventEmitter();
  @Output() public onSelectToggle: EventEmitter<any> = new EventEmitter();
  @Output() public onQuickViewToggle: EventEmitter<any> = new EventEmitter();
  @Output() public onSharedToggle: EventEmitter<any> = new EventEmitter();
  @Output() public onHideCard: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {}


  /**
   * Delete emits event.
   *
   * @returns {void}
   */
  public onDeleteSearchCard(): void{
    this.onDeleteCard.emit(this.cardDetails);
  }

  public onHideSearchCard(): void{
    console.log("this.cardDetails",this.cardDetails)
    this.onHideCard.emit(this.cardDetails);
  }

  /**
   * Select emits event.
   *
   * @returns {void}
   */
  public onSelectEmitted(): void{
    this.onSelectToggle.emit(this.cardDetails);
  }

  /**
   * Enables or disables the quick for the saved search.
   *
   * @param {MatCheckbox} event
   * @returns {void}
   */
  public onEnableQuickSearch(event: MatCheckbox){
    this.onQuickViewToggle.emit({card: this.cardDetails, value: event });
  }

  /**
   * Enables the share on the search card.
   *
   * @param {MatCheckbox} event
   * @returns {void}
   */
  public onEnableShare(event: MatCheckbox){
    this.onSharedToggle.emit({card: this.cardDetails, value: event})
  }
}
